import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient, IPaginatedResponse } from "./ApiClient";
import { IOrthodonticLkgCfPatientExtension, IOrthodonticLkgCfPatientExtensionSearchParams, IOrthodonticLkgCfPatientExtensionStatus } from "../models/IOrthodonticLkgCfPatientExtension";
import { objectToQueryString } from "../helpers/ApiHelper";

export class OrthodonticLkgCfPatientExtensionSearchApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    searchOrthodonticLkgCfPatientExtensions(searchParams: IOrthodonticLkgCfPatientExtensionSearchParams, success: (data: IPaginatedResponse<IOrthodonticLkgCfPatientExtension[]>) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        this.getPaginated<IOrthodonticLkgCfPatientExtension[]>(`${Utils.LIB_API_BASE_URL}/orthodonticLkgCfPatientExtensionSearch?${queryString}`, success, undefined, final)
    }

    getOrthodonticLkgCfPatientExtensionStatuses(success: (data: IOrthodonticLkgCfPatientExtensionStatus[]) => void, final?: () => void) {
        this.get<IOrthodonticLkgCfPatientExtensionStatus[]>(`${Utils.LIB_API_BASE_URL}/orthodonticLkgCfPatientExtensionSearch/orthodonticLkgCfPatientExtensionStatuses`, success, undefined, final)
    }
}